import { Icon } from '@/components/Icon'
import { ContentLabel } from '@/components/ContentLabel'
import {
  BillingItem,
  BillingItemContent,
  BillingItemExtras,
  BillingItemSubtitle,
  BillingItemTitle,
  BillingItemVisual,
} from '@/features/billing/components/BillingItemList'
import { IconVisual } from '@/components/IconVisual'
import { Button } from '@/components/Button'

export interface ProfilePayoutMethodProps {
  type: string
  stripeAccountId: string
  onReplace: () => unknown
}

/**
 * The member's payout method.
 */
export function ProfilePayoutMethod({
  type,
  stripeAccountId,
  onReplace,
}: ProfilePayoutMethodProps) {
  return (
    <>
      <ContentLabel>Payout Method</ContentLabel>
      <BillingItem>
        <PayoutMethodType type={type} stripeAccountId={stripeAccountId} />

        <BillingItemExtras>
          <Button label="Replace" variant="default" onPress={onReplace} />
        </BillingItemExtras>
      </BillingItem>
    </>
  )
}

interface PayoutMethodTypeProps {
  type: string
  stripeAccountId: string
}

function PayoutMethodType({ type, stripeAccountId }: PayoutMethodTypeProps) {
  switch (type) {
    case 'Stripe': {
      return (
        <>
          <BillingItemVisual>
            <Icon color="#6772E5" size={48} name="stripe-logo" />
          </BillingItemVisual>

          <BillingItemContent>
            <BillingItemTitle testId="payout-method-title">
              via Stripe
            </BillingItemTitle>
            <BillingItemSubtitle testId="payout-method-subtitle">
              {stripeAccountId}
            </BillingItemSubtitle>
          </BillingItemContent>
        </>
      )
    }
    default: {
      return (
        <>
          <BillingItemVisual>
            <IconVisual>
              <Icon name="info" />
            </IconVisual>
          </BillingItemVisual>
          <BillingItemContent>
            <BillingItemTitle testId="payout-method-title">
              Unknown Payout Method "{type}"
            </BillingItemTitle>
            <BillingItemSubtitle>
              This version of the app does not recognize this payout type.
            </BillingItemSubtitle>
          </BillingItemContent>
        </>
      )
    }
  }
}
